/** Organization ID for the Impact Report */
export const ORGID = "365";
export * from "./cleaner.js";
export * from "./connector.js";
export { convertImpacts, descriptionMap } from "./impacts.js";
export * from "./types/index.js";
